import { request } from '@/utils/request'

// 授权接口
const authApi = {

  /** 检查 token 是否过期 */
  checkToken: () => request.get('checkToken', undefined, { withoutCheck: true }),

  /** 【】账号登录 */
  loginByAccount: (params: Recordable) => request.post('login', params),

  /** 【】账号登录 */
  loginCaptchaPictureSrc: '/api/admin/captcha/api',

  /** 登出 */
  logout: () => request.get('logout'),

  /** 获取用户信息 */
  getUserInfo: () => request.get('user/info'),

  /** 获取手机验证码 */
  getCaptcha: (params: Recordable) => request.post('/global/captcha/mobile', params),
}

export { authApi }


